import {z} from 'zod';

import {TaskStatus} from './types';

const downloadUrlResultSchema = z.discriminatedUnion(`type`, [
  z.object({
    type: z.literal(TaskStatus.Success),
    payload: z.object({
      url: z.string(),
    }),
  }),
]);

export const isDownloadUrlResult = downloadUrlResultSchema.safeParse;
